import { render, staticRenderFns } from "./RelationsSelector.vue?vue&type=template&id=74054644&scoped=true"
import script from "./RelationsSelector.vue?vue&type=script&lang=js"
export * from "./RelationsSelector.vue?vue&type=script&lang=js"
import style0 from "./RelationsSelector.vue?vue&type=style&index=0&id=74054644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74054644",
  null
  
)

export default component.exports